/* RH Now Phase 6F: support RHGC personalization in dynamically injected Xtra quick shop. */
(function () {
  'use strict';
  function sync(root) {
    if (!root) return;
    var chosen = root.querySelector('input[name="properties[Card Data Method]"]:checked');
    if (!chosen) return;
    root.querySelectorAll('[data-method]').forEach(function (panel) {
      var active = panel.getAttribute('data-method') === chosen.value;
      panel.hidden = !active;
      panel.querySelectorAll('input,select,textarea').forEach(function (field) {
        field.disabled = !active;
        if (field.tagName === 'SELECT') field.required = active;
      });
    });
  }
  function initialize(scope) {
    if (!scope || !scope.querySelectorAll) return;
    if (scope.matches && scope.matches('.rhgc-pilot, .rh-gift-order-box')) sync(scope);
    scope.querySelectorAll('.rhgc-pilot, .rh-gift-order-box').forEach(sync);
  }
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.matches('input[name="properties[Card Data Method]"]')) {
      sync(target.closest('.rhgc-pilot, .rh-gift-order-box'));
    }
  });
  function ready() {
    initialize(document);
    var quickshop = document.getElementById('quickshop');
    if (quickshop && typeof MutationObserver !== 'undefined') {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          initialize(quickshop);
        });
      }).observe(quickshop, {childList:true,subtree:true});
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
